import { Stack, Text } from "@bookingcom/bui-react";

type ChartYaxisTitleProps = {
  titleText: string;
  opposite?: boolean;
};

export const ChartYaxisTitle = ({ titleText, opposite = false }: ChartYaxisTitleProps) => {
  return (
    <Stack className={`apexcharts-yaxis-title${opposite ? "-opposite" : ""}-container`}>
      <Text variant="strong_2">{titleText}</Text>
    </Stack>
  );
};
